module.exports = __webpack_public_path__ + "img/search.18870ce5.png";